package at.theatervogelweide.admin.contract.accounts

import at.theatervogelweide.admin.contract.AdminResult
import at.theatervogelweide.admin.contract.VersionedId
import kotlinx.rpc.annotations.Rpc

/**
 * Konten (#66), sorted by e-mail address. Every call answers with [at.theatervogelweide.admin.contract.AdminError.forbidden]
 * unless the signed-in account is a superuser at that moment.
 *
 * Nobody can disable, demote or delete their own account, or the last superuser. Disabling or deleting an account ends
 * its sessions and its MCP connections at once.
 */
@Rpc
interface AccountsService {
    suspend fun list(): AdminResult<List<AccountListEntry>>

    suspend fun load(id: Long): AdminResult<AccountEditor>

    /** Creates the account without a password and answers with its first one-time link. */
    suspend fun create(draft: AccountDraft): AdminResult<AccountWithLink>

    suspend fun save(account: VersionedId, draft: AccountDraft): AdminResult<AccountEditor>

    /**
     * "Link erzeugen": a new one-time link, e.g. for a forgotten password; earlier links of the account stop working.
     * The old password keeps working until the link is used. Not for disabled accounts.
     */
    suspend fun createLink(id: Long): AdminResult<AccountWithLink>

    /** News items published under the account's name lose their author. */
    suspend fun delete(account: VersionedId): AdminResult<Unit>
}
